<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-vgroup width="250px" height="100%" class="section-container"
    ><!-- zone champs libres & filtre -->
    <wiz-label [wizLabel]="'$.pivot.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
    <wiz-list
      #freeList
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      id="freeList"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
    <filter-component #mainFilter> </filter-component>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%">
    <!-- zone détail : poser les champs -->

    <wiz-hgroup width="100%" height="70%"><!-- zone lignes -->

      <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container"><!-- champs lignes -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-line</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.row.agg.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstRow
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

    </wiz-hgroup>

    <wiz-hgroup width="100%" height="30%"><!-- datas -->
      <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container"><!-- champs datas -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-formula</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.data.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstData
          id="lstData"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

      <wiz-vgroup width="40%" height="100%" minHeight="100px" horizontalAlign="end" style="display: none"><!-- champs filtres désactivée -->
    
        <wiz-list #lstColumn></wiz-list>
        <wiz-list #lstIntegrity></wiz-list>
        <wiz-list #lstFilter></wiz-list>
        <wiz-list #lstGroup></wiz-list>
        <wiz-checkbox #cbDeleteIntegrity></wiz-checkbox>
        <wiz-checkbox #cbUpdateIntegrity></wiz-checkbox>
      </wiz-vgroup>
    </wiz-hgroup>

    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <wiz-vgroup width="100%">
        <wiz-checkbox #cbShowDeleteCol [visible]="false" [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
        <wiz-checkbox #cbShowDeleteRecurseCol [visible]="false" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
        <wiz-checkbox #cbShowSelectCol [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
      </wiz-vgroup>
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>
  </wiz-vgroup>
  <!-- fin zone détail -->
</wiz-hgroup>
